import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

// NOTE: review - combine with date adapters

@Pipe({
  name: 'zoneDate'
})
export class ZoneDatePipe extends DatePipe implements PipeTransform {
  transform(value: Date|string|number, format?: string): string|null;
  transform(value: null|undefined, format?: string): null;
  transform(value: Date|string|number|null|undefined, format?: string): string|null;
  transform(value: string | Date, format: string = 'mediumDate'): string {
    const zone = new Date(value).toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
    return `${super.transform(value, format)} ${zone}`;
  }
}
